<!--商机-->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <dynamic-search
        :data="tableFilterList(tableHead)"
        @search="dynamicSearch">
        <template v-slot:next>
          <el-button icon="el-icon-plus" @click="$router.push('business/form')">新增</el-button>
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :total="total"
        stripe
        :offset="20"
        :page="5">
        <template #toolbar="scope">
         <el-button type="text" size="mini" icon="el-icon-edit" @click="edit(scope.row)"></el-button>
          <el-popover :ref="scope.row.id" placement="top" width="180">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button
                type="primary"
                size="mini"
                @click="subDelete(scope.row.id)"
              >确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>
          </el-popover>
        </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>

import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";
import { delBusiess } from "@/api/basic";
import {tableSataus} from '@/views/bill/mixins/status'
  export default {
    name: "Business",
    components: {
      DynamicSearch,
    },
    mixins: [DataTableMixin,tableSataus],
    data() {
      return {
        tableHead: [
          {
            label: '商机号',
            prop: 'businessCode',
            query: {
              type: 'input'
            },
          },
          {
            label: '经营人',
            prop: 'operatorName'
          },
          {
            label: '商机所有人',
            prop: 'ownerName',
          },
          {
            label: '报备人',
            prop: 'operatorName',
          },
            {
            label: '所属部门',
            prop: 'dept',
          },
           {
            label: '客户',
            prop: 'customerName',
          },
             {
          label: "状态",
          prop: "billState",
           formatter: (state) => {
              return this.statusName(state)
            }
        }
        ],
        tableData: []
      }
    },
     created() {
    // 列表数据初始化
    this.$nextTick(() => {
      this.dataTableInit();
    });
  },
    methods: {
      dataTableBeforeInit() {
      this._url = "/business";
      const params = { page: this.page, size: this.offset };
      this._params = Object.assign(params, this._query);
      return true;
    },
    dynamicSearch() {

    },
    edit(row) {
      console.log(row);
      this.$router.push("business/form?id=" + row.id);
    },
    // 删除
    subDelete(id) {
      console.log(id);
      delBusiess(id).then(res => {
        console.log(res);
          this.dataTableInit();
          this.$notify({
            title: "删除成功",
            type: "success",
            duration: 2500
          });
      });
    }
    }
  }
</script>

<style scoped lang="scss">
</style>
